const s = {
  name: "Hands01111",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.8,2.7C14.4,2.2,15.2,2,16,2c2.2,0,4,1.8,4,4v0.6C20.6,6.2,21.3,6,22,6c2.3,0,4,2.1,4,4.4V27
			c0,7.2-5.8,13-13,13S0,34.2,0,27V6c0-2.2,1.8-4,4-4c0.8,0,1.6,0.2,2.2,0.7C6.8,1.1,8.3,0,10,0C11.7,0,13.2,1.1,13.8,2.7z M10,2
			C8.9,2,8,2.9,8,4v15h2c0.7,0,1.4,0.2,2,0.5V4C12,2.9,11.1,2,10,2z M20,10.4V21h2v2h-8c0,2.2-1.8,4-4,4H6v-2h4c1.1,0,2-0.9,2-2
			s-0.9-2-2-2H4c-1.1,0-2,0.9-2,2v4c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11V10.4C24,9,23,8,22,8C21,8,20,9,20,10.4z M18,21V6
			c0-1.1-0.9-2-2-2s-2,0.9-2,2v15H18z M4,19h2V6c0-1.1-0.9-2-2-2C2.9,4,2,4.9,2,6v13.5C2.6,19.2,3.3,19,4,19z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Hands01111
};
